<template>
  <div class="form-group bg-light-2 p-4 shadow-lg mt-5">
    <h4>Video promocional</h4>
    <p>
      <b>Todo video será obtenido de youtube.</b> Solo escribe el código del
      video, ejemplo https://www.youtube.com/watch?v=
      <span class="font-weight-bolder text-danger">HKwnHrIbHwc</span> (solo lo
      rojo)
    </p>
    <hr />
    <input
      type="text"
      :value="videoYT"
      @change="handleChangeVideoYT"
      class="form-control"
      placeholder="HKwnHrIbHwc"
    />
    <div class="embed-responsive embed-responsive-16by9 mt-5" v-if="videoYT">
      <iframe
        width="560"
        height="315"
        :src="'https://www.youtube.com/embed/' + videoYT"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "VideoPublication",
  props: {
    videoYT: {
      type: String,
      default: "",
    },
  },
  methods: {
    handleChangeVideoYT(e) {
      this.$emit("handleChangeVideoYT", e.target.value);
    },
  },
};
</script>